const form = {
  formId: "new-user-form",
  formField: {
    taxpayersName: {
      name: "taxpayersName",
      label: "Người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayersId: {
      name: "taxpayersId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    htldl: {
      name: "htldl",
      label: "Hỗ trợ lấy dữ liệu từ năm trước",
      type: "text",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Lập bảng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người lập bảng",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Kế toán trưởng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên kế toán trưởng",
    },
    signer: {
      name: "signer",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người đại diện theo pháp luật",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày lập",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày lập",
    },
  },
};

export default form;
